import React from "react";
import { RenderMoneda, RenderNumero, RenderDateTime } from "Utils/renderField/renderTableField";
import { formatFraction, formatDifference } from "utility/variables";

const MovimientosPDF = (props) => {
  const {
    conf_tipo_negocio,
    conteos_procesados = [],
    fracciones_no_conteadas = []
  } = props;

  const totales = conteos_procesados.reduce((acc, item) => {
    const diferencia = item.cantidad_antes - item.cantidad_fisica;
    const precio = (item.fraccion && item.fraccion.precio !== undefined && item.fraccion.precio !== null)
      ? item.fraccion.precio
      : 0;
    const costoPromedio = (item.fraccion && item.fraccion.costo_promedio_ponderado !== undefined && item.fraccion.costo_promedio_ponderado !== null)
      ? item.fraccion.costo_promedio_ponderado
      : 0;
    const precioSucursal = (item.precio_sucursal && item.precio_sucursal !== undefined && item.precio_sucursal !== null)
      ? item.precio_sucursal
      : 0;
    const precioDiferencia = diferencia * precioSucursal;
    
    acc.totalDiferencia += diferencia;
    acc.totalPrecioDiferencia += precioDiferencia;
    acc.totalCostoPromedio += costoPromedio;
    acc.totalPrecioUnitario += precioSucursal;
    
    return acc;
  }, { totalDiferencia: 0, totalPrecioDiferencia: 0, totalPrecioUnitario: 0 , totalCostoPromedio: 0 });

  // Calcular total precio compra (costoPromedio * cantidad_fisica para cada item)
  const totalPrecioCompra = conteos_procesados.reduce((acc, item) => {
    const costoPromedio = (item.fraccion && item.fraccion.costo_promedio_ponderado !== undefined && item.fraccion.costo_promedio_ponderado !== null)
      ? item.fraccion.costo_promedio_ponderado
      : 0;
    const cantidadFisica = item.cantidad_fisica || 0;
    return acc + (costoPromedio * cantidadFisica);
  }, 0);

  const fechaConteo = (conteos_procesados &&
      conteos_procesados[0] &&
      conteos_procesados[0].actualizado_en)
      ? conteos_procesados[0].actualizado_en
      : new Date();

  return (
    <div className="table-responsive p-3">
      <div className="card shadow-sm mb-4">
        <div className="card-header bg-primary text-white">
          <h5 className="card-title mb-0">Reporte de Conteo de Inventario</h5>
        </div>
        <div className="card-body">
          <div className="row mb-3">
            <div className="col-md-6">
              <p className="mb-1">
                <strong>Fecha de conteo:</strong>{" "}
                <RenderDateTime fecha={fechaConteo} />
              </p>
            </div>
            <div className="col-md-6">
              <p className="mb-1">
                <strong>Total productos conteados:</strong> {conteos_procesados.length}
              </p>
              {/* Nuevo: Total Precio Compra */}
              <p className="mb-1">
                <strong>Total Precio Compra:</strong> <RenderMoneda monto={totalPrecioCompra} />
              </p>
            </div>
          </div>

          {/* Tabla de productos conteados */}
          <div className="card shadow-sm mb-4">
            <div className="card-header bg-secondary text-white">
              <h6 className="card-title mb-0">Productos Contados</h6>
            </div>
            <div className="card-body">
              <table className="table table-bordered">
                <thead className="table-info">
                  <tr>
                    <th className="text-wrap">Producto</th>
                    <th className="text-nowrap">Código</th>
                    {conf_tipo_negocio === "Joyeria" && <th>Kilataje</th>}
                    {conf_tipo_negocio === "Joyeria" && <th>Peso</th>}
                    <th>Existencia Sistema</th>
                    <th>Existencia Real</th>
                    <th>Diferencia</th>
                    <th>Precio Unitario</th>
                    <th>Precio Costo</th>
                    <th>Precio Diferencia</th>
                  </tr>
                </thead>
                <tbody>
                  {conteos_procesados.map((item) => {
                    const costoPromedio = (item.fraccion && item.fraccion.costo_promedio_ponderado !== undefined && item.fraccion.costo_promedio_ponderado !== null)
                      ? item.fraccion.costo_promedio_ponderado
                      : 0;
                    const diferencia = item.cantidad_antes - item.cantidad_fisica;
                    console.log(item)
                    console.log('diferencia: ',diferencia)
                    const precio = (item.fraccion && item.fraccion.precio !== undefined && item.fraccion.precio !== null)
                      ? item.fraccion.precio
                      : 0;

                    const precioSucursal = (item.precio_sucursal && item.precio_sucursal !== undefined && item.precio_sucursal !== null)
                      ? item.precio_sucursal
                      : 0;
                    const precioDiferencia = diferencia * precioSucursal;
                    const productoNombre =
                      item.fraccion && item.fraccion.producto && item.fraccion.producto.nombre
                        ? item.fraccion.producto.nombre
                        : "Sin nombre";
                        const codigoBarras =
                        item && item.fraccion && item.fraccion.codigos_barras && 
                        Array.isArray(item.fraccion.codigos_barras) && 
                        item.fraccion.codigos_barras.length > 0 && 
                        item.fraccion.codigos_barras[0] && 
                        item.fraccion.codigos_barras[0].codigo !== undefined && 
                        item.fraccion.codigos_barras[0].codigo !== null
                          ? item.fraccion.codigos_barras[0].codigo
                          : "---";
                    const kilataje = (conf_tipo_negocio === "Joyeria" &&
                      item.fraccion && item.fraccion.producto && item.fraccion.producto.kilataje)
                        ? item.fraccion.producto.kilataje
                        : "---";
                    const peso = (conf_tipo_negocio === "Joyeria" &&
                      item.fraccion && item.fraccion.producto && item.fraccion.producto.peso)
                        ? item.fraccion.producto.peso
                        : "---";
                    return (
                      <tr key={item.id}>
                        <td className="text-wrap">{productoNombre}</td>
                        <td className="text-nowrap">{codigoBarras}</td>
                        
                        {conf_tipo_negocio === "Joyeria" && (
                          <td className="text-nowrap">{kilataje}</td>
                        )}
                        
                        {conf_tipo_negocio === "Joyeria" && (
                          <td className="text-nowrap">{peso}</td>
                        )}
                        
                        <td>
                          {conf_tipo_negocio === "Telas"
                            ? formatFraction(item.cantidad_antes)
                            : <RenderNumero monto={item.cantidad_antes} />}
                        </td>
                        <td>
                          {conf_tipo_negocio === "Telas"
                            ? formatFraction(item.cantidad_fisica)
                            : <RenderNumero monto={item.cantidad_fisica} />}
                        </td>
                        <td>
                          {conf_tipo_negocio === "Telas"
                            ? formatDifference(diferencia) 
                            : <RenderNumero monto={diferencia} />}
                        </td>
                        <td><RenderMoneda monto={precioSucursal} /></td>
                        <td><RenderMoneda monto={costoPromedio} /></td>
                        <td><RenderMoneda monto={precioDiferencia} /></td>
                      </tr>
                    );
                  })}
                </tbody>
                
                <tfoot>
                  <tr className="table-info">
                    <td colSpan={conf_tipo_negocio === "Joyeria" ? 6 : 4} className="text-end">
                      <strong>Totales:</strong>
                    </td>
                    <td><RenderNumero monto={totales.totalDiferencia} /></td>
                    <td><RenderMoneda monto={totales.totalPrecioUnitario} /></td>
                    <td><RenderMoneda monto={totales.totalCostoPromedio} /></td>
                    <td><RenderMoneda monto={totales.totalPrecioDiferencia} /></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {/* Sección de productos no conteados */}
          {fracciones_no_conteadas.length > 0 && (
            <div className="card shadow-sm mt-4">
              <div className="card-header bg-warning text-dark">
                <h6 className="card-title mb-0">
                  Productos No Contados ({fracciones_no_conteadas.length})
                </h6>
              </div>
              <div className="card-body">
                <table className="table table-bordered">
                  <thead className="table-info">
                    <tr>
                      <th className="text-wrap">Producto</th>
                      <th>Código</th>
                      {conf_tipo_negocio === "Joyeria" && <th>Kilataje</th>}
                      {conf_tipo_negocio === "Joyeria" && <th>Peso</th>}
                      <th>Existencia Sistema</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fracciones_no_conteadas.map((fraccion) => (
                      <tr key={fraccion.id}>
                        <td className="text-wrap">
                          {(fraccion.producto && fraccion.producto.nombre)
                            ? fraccion.producto.nombre
                            : "Sin nombre"}
                        </td>
                        <td>
                            {
                              fraccion.codigos_barras &&
                              Array.isArray(fraccion.codigos_barras) &&
                              fraccion.codigos_barras.length > 0 &&
                              fraccion.codigos_barras[0].codigo
                                ? fraccion.codigos_barras[0].codigo
                                : "---"
                            }
                          </td>
                        {conf_tipo_negocio === "Joyeria" && (
                          <td>
                            {(fraccion.producto && fraccion.producto.kilataje)
                              ? fraccion.producto.kilataje
                              : "---"}
                          </td>
                        )}
                        
                        {conf_tipo_negocio === "Joyeria" && (
                          <td>
                            {(fraccion.producto && fraccion.producto.peso)
                              ? fraccion.producto.peso
                              : "---"}
                          </td>
                        )}
                        
                        <td>
                          {conf_tipo_negocio === "Telas"
                            ? formatFraction(fraccion.total_inventario ? fraccion.total_inventario : 0)
                            : <RenderNumero monto={fraccion.total_inventario ? fraccion.total_inventario : 0} />}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MovimientosPDF;